import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Button from '../../../../../../../../components/global/Button';
import EditIcon from '../../../../../../../../components/icons/EditIcon';

const propTypes = {
  values: PropTypes.shape({
    relationship: PropTypes.string,
  }),
  onUpdate: PropTypes.func,
};

const GraduationEventReviewDetails = ({ values, onUpdate }) => {
  return (
    <>
      <tr>
        <td className="text-left">
          <div className="d-flex align-items-center">
            <div className="d-flex flex-column mr-1">
              <h3 className="mb-0">Name of celebrated</h3>
              <p className="text-base">
                {values.first_name} {values.last_name}
              </p>
            </div>
            <Button
              btnStyle="link"
              btnSize="sm"
              onClick={onUpdate}
              className="ml-auto review-step-edit-icon"
            >
              <EditIcon color="#0d84fe" size="22px" className="ml-1" />
            </Button>
          </div>
        </td>
      </tr>
      <tr>
        <td className="text-left">
          <div className="d-flex align-items-center">
            <div className="d-flex flex-column mr-1">
              <h3 className="mb-0">Graduation date</h3>
              <p className="text-base">
                {values.graduation_date
                  ? moment(values.graduation_date).format('MMMM Do YYYY')
                  : 'N/A'}
              </p>
            </div>
            <Button
              btnStyle="link"
              btnSize="sm"
              onClick={onUpdate}
              className="ml-auto review-step-edit-icon"
            >
              <EditIcon color="#0d84fe" size="22px" className="ml-1" />
            </Button>
          </div>
        </td>
      </tr>
    </>
  );
};

GraduationEventReviewDetails.propTypes = propTypes;

export default GraduationEventReviewDetails;
